<template>
  <div class="unauthenticated">
    <header class="header">
      <div v-if="!isUs" class="logo"><img src="@/assets/images/logo_kurazushi.svg" alt="" /></div>
      <div v-if="isUs" class="logo"><img src="@/assets/images/welcome-us/logo.svg" alt="" /></div>
    </header>
    <b-container fluid>
      <div class="content">
        <h1 class="h4">{{ $t('error.unableToAuthenticate') }}</h1>
        <img class="image" src="@/assets/images/error.png" alt="" />
        <p class="errorMessage">{{ errorMessage }}</p>
        <b-button class="button-black" @click="backtotop">{{ $t('error.backToTop') }}</b-button>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      errorMessage: 'auth/getErrorMessage',
    }),
    isRoot() {
      return this.$route.path === '/'
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  methods: {
    ...mapActions({
      setAuth: 'auth/setAuth',
    }),
    backtotop() {
      this.setAuth('unabled')
      if (this.isRoot) return
      this.$router.push({ name: 'shopMenu' })
    },
  },
}
</script>
<style lang="scss" scoped>
.unauthenticated {
  text-align: center;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.25);
  }
  .logo {
    width: 56px;

    & img {
      width: 100%;
    }
  }
  .content {
    padding-top: 36px;
  }
  .h4 {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: bold;
  }
  .image {
    margin-top: 24px;
    height: 60px;
  }
  .errorMessage {
    margin: 20px 0 0;
    font-size: 14px;
    white-space: pre-wrap;
  }
  .button-black {
    min-width: 240px;
    margin: 40px 0;
    background: #333;
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
